import {
  Button,
  ButtonGroup,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Link,
  Spacer,
} from "@chakra-ui/react";
import { SyntheticEvent, useCallback, useMemo, useState } from "react";
import { GoX } from "react-icons/go";
import { HiOutlineSearch } from "react-icons/hi";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import { AuthService } from "src/common/AuthService";
import { StaffRole } from "src/common/types";

export const StaffFilterBar = () => {
  const userRole = AuthService.hooks.useStaffUserRole();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const [name, setName] = useState<string>(searchParams.get("name") || "");

  const onSubmit = useCallback(
    (newSp: URLSearchParams) => {
      newSp.delete("pageNumber");
      searchParams.sort();
      newSp.sort();

      if (searchParams.toString() !== newSp.toString()) {
        navigate(`?${newSp.toString()}`);
      }
    },
    [searchParams]
  );

  const handleSubmit = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault();
      const newSp = new URLSearchParams(location.search);

      if (name) {
        newSp.set("name", name);
      } else {
        newSp.delete("name");
      }

      onSubmit(newSp);
    },
    [location.search, name, searchParams]
  );

  const clearSearch = () => {
    const newSp = new URLSearchParams(location.search);
    newSp.delete("name");
    setName("");

    onSubmit(newSp);
  };

  return (
    <Flex flexDirection="row">
      <form onSubmit={handleSubmit}>
        <InputGroup width={503}>
          <InputLeftElement pointerEvents="none" color="gray.300">
            <HiOutlineSearch />
          </InputLeftElement>
          <Input
            value={name}
            onChange={({ currentTarget: { value } }) => setName(value)}
            onBlur={handleSubmit}
            placeholder="Search for staff name"
          />
          <InputRightElement>
            <Button variant="ghost" onClick={clearSearch}>
              <GoX />
            </Button>
          </InputRightElement>
        </InputGroup>
      </form>
      {userRole === StaffRole.Admin && (
        <>
          <Spacer width={8} />
          <ButtonGroup>
            <Link as={RouterLink} to={`/staff/invite`}>
              <Button colorScheme="brand.blue">Add Staff</Button>
            </Link>
          </ButtonGroup>
        </>
      )}
    </Flex>
  );
};
